import { defineMessages } from 'react-intl';

export default defineMessages({
    externalResourceRequestFormIconLabel: {
        id: 'cv.external-resource-fallback-icon.external-link-request-form-icon-label',
        defaultMessage: 'Request form',
        description: 'Label for Request form external link icon',
    },
    externalResourceArticleIconLabel: {
        id: 'cv.external-resource-fallback-icon.external-link-knowledge-icon-label',
        defaultMessage: 'Article',
        description: 'Label for knowledge article external link icon',
    },
    externalResourceHelpChannelIconLabel: {
        id: 'cv.external-resource-fallback-icon.external-link-help-channel-icon-label',
        defaultMessage: 'Help channel',
        description: 'Label for channel external link icon',
    },
});
